import PolygonOperations from 'polygon-clipping';
import { ANNOTATION_TYPE } from '../../../constants';
import type { AnnotationReviewStoreT, AnnotationStoreT, AnnotationT, LabelStateT, PolygonAnnotationT } from '../../../types';
import { getParentAnnotations, removeDeletedChildrenFromParent } from '../annotations/helpers';
export const transformRectanglesToPolygons = (annotations: AnnotationT[]) => {
  annotations.forEach((annotation, idx) => {
    if (annotation.annotationType !== ANNOTATION_TYPE.RECTANGLE) return;
    const {
      x,
      y,
      height,
      width
    } = annotation.data;
    annotation = {
      ...annotation,
      annotationType: ANNOTATION_TYPE.POLYGON,
      data: {
        points: [[x, y], [x + width, y], [x + width, y + height], [x, y + height]]
      }
    };
    annotations[idx] = annotation;
  });
};
export const getMergedPolygonDataPoints = (annotations: PolygonAnnotationT[]) => {
  const polygonsDataPoints = annotations.map(annotation => [annotation.data.points]);
  // union method returns array of multi polygons, so our answer will be the first polygon of the first multi polygon
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  return PolygonOperations.union(polygonsDataPoints[0], ...polygonsDataPoints.slice(1))[0][0].map(points => ([points[0], points[1]] as [number, number]));
};
export const getSubtractedPolygonDataPoints = (annotations: PolygonAnnotationT[]) => {
  const polygonsDataPoints = annotations.map(annotation => [annotation.data.points]);
  // difference method returns array of multi polygons, so our answer will be the first polygon of the first multi polygon
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  return PolygonOperations.difference(
  // @ts-expect-error todo(ts-migration) TS2345 Argument of type '[number, number][][] | undefined' is not assignable to parameter of type 'Geom'.
  polygonsDataPoints[0], ...polygonsDataPoints.slice(1))[0][0].map(points => ([points[0], points[1]] as [number, number]));
};
export const deleteSelectedAnnotations = (state: LabelStateT, selectedAnnotationIds: string[]): {
  updatedFrames: LabelStateT['frames'];
  deletedAnnotations: AnnotationStoreT;
  updatedAnnotationReviewStore: AnnotationReviewStoreT;
  deletedReviewData: AnnotationReviewStoreT;
  parentAnnotations: AnnotationStoreT;
} => {
  const {
    currentFrame
  } = state;
  let frames = [...state.frames];
  const [updatedAnnotationStore, deletedAnnotations] = Object.entries(
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  frames[currentFrame].annotationStore).reduce<[AnnotationStoreT, AnnotationStoreT]>(([updatedStore, deletedStore], [annotationId, annotation]) => {
    return selectedAnnotationIds.includes(annotationId) ? [updatedStore, {
      ...deletedStore,
      [annotationId]: annotation
    }] : [{
      ...updatedStore,
      [annotationId]: annotation
    }, deletedStore];
  }, [{}, {}]);
  const [updatedAnnotationReviewStore, deletedReviewData] = Object.entries(state.annotationReviewStore).reduce<[AnnotationReviewStoreT, AnnotationReviewStoreT]>(([updatedReviewStore, deletedReviewStore], [annotationId, annotation]) => {
    return selectedAnnotationIds.includes(annotationId) ? [updatedReviewStore, {
      ...deletedReviewStore,
      [annotationId]: annotation
    }] : [{
      ...updatedReviewStore,
      [annotationId]: annotation
    }, deletedReviewStore];
  }, [{}, {}]);

  // @ts-expect-error todo(ts-migration) TS2322 Type '{ annotationStore: AnnotationStoreT; imageUrl?: string | undefined; annotationMLStore?: AnnotationStoreT; annotationConsensusStore?: AnnotationStoreT; }' is not assignable to type 'FrameStateT'....
  frames[currentFrame] = {
    ...frames[currentFrame],
    annotationStore: updatedAnnotationStore
  };
  const parentAnnotations = getParentAnnotations(
  // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
  frames[currentFrame].annotationStore, deletedAnnotations);
  const updatedFrames = [...frames.slice(0, currentFrame), removeDeletedChildrenFromParent(frames, parentAnnotations, deletedAnnotations, currentFrame), ...frames.slice(currentFrame + 1)];
  return {
    updatedFrames,
    deletedAnnotations,
    updatedAnnotationReviewStore,
    deletedReviewData,
    parentAnnotations
  };
};